import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type RiskModelUniverseCoveragePreviewProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;

  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'risk_model_coverage_snapshot', string>;
  goFullScreen?: (_b: string) => void;
  fullScreen?: boolean;

  context?: ts.types.riskModel.RiskModelAnalysisContext;
  queryParams?: { initial?: string };
};

const RiskModelUniverseCoveragePreview = ({
  id,
  loadWidgetData,
  widgetPaths,
  mode,
  context,
  params,
  setParams,
  fullScreen,
  goFullScreen,
  queryParams,
}: RiskModelUniverseCoveragePreviewProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        loadWidgetData={loadWidgetData}
        snapshot={widgetPaths['risk_model_coverage_snapshot']}
        fullScreen={fullScreen}
        queryParams={queryParams}
        goFullScreen={goFullScreen}
        snapshotDate={params.preview_date}
        context={context}
        params={params as Params}
        setParams={setParams}
      />
    </>
  );

  return (
    <>
      {mode == 'edit' ? (
        <Form
          params={params}
          setParams={setParams}
          startDate={context?.start_date}
          endDate={context?.end_date}
          universeId={context?.universe_id}
        />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default RiskModelUniverseCoveragePreview;
